import { render } from "./MenuIcon.vue?vue&type=template&id=3fb44a17"
import script from "./MenuIcon.vue?vue&type=script&lang=js"
export * from "./MenuIcon.vue?vue&type=script&lang=js"
script.render = render

export default script